import template from './header.html'

export let header = {
  bindings: {
    teacherName: '<',
    teacherId: '<',
    workplanId: '<',
    activitytypeId: '<',
    workplanteacherId: '<',
    btnBitacora: '<'
  },
  template: template,
  controllerAs: 'vm',
  controller: ['$scope', '$state', '$cookies', '$stateParams', 'GlobalConfig', 'WorkPlanSrv',
    'WorkPlanModalSrv', 'ReviewSrv', 'Validations', 'Setters', 'Requests', '$mdDialog', 'ngNotify', 'GlobalSrv',
    function headerCtrl ($scope, $state, $cookies, $stateParams, GlobalConfig, WorkPlanSrv, WorkPlanModalSrv, ReviewSrv, Validations, Setters, Requests, $mdDialog, ngNotify, GlobalSrv) {
      const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
      const currentModule = $state.current.module
      const currentRoleId = JSON.parse($cookies.get('hasRoleId'))
      const user = JSON.parse($cookies.get('currentUser'))

      angular.extend(this, {
        user: user,
        mainLabel: $state.current.data.title,
        executionCompleted: true,
        approvalCompleted: false,
        evaluationCompleted: true,
        reviewExecutionCompleted: false,
        colClassTexts: 'col-md-3',
        colClassButtons: 'col-md-9',
        userId: 0
      })

      this.entries = {}

  // methods
      angular.extend(this, {
        addActivityTeaching: addActivityTeaching,
        addActivityAM: addActivityAM,
        addRolesAM: addRolesAM,
        addCommitteParticipationAM: addCommitteParticipationAM,
        addLearningComunityCP: addLearningComunityCP,
        addCourseExternalCP: addCourseExternalCP,
        viewOfferCoursesCP: viewOfferCoursesCP,
        viewTransversalProjects: viewTransversalProjects,
        inReview: Validations.inReview(currentStage),
        inApproval: Validations.inApproval(currentStage),
        inExecution: Validations.inExecution(currentStage),
        inReviewExecution: Validations.inReviewExecution(currentStage),
        inEvaluation: Validations.inEvaluation(currentStage),
        inAcademicManagement: Validations.inAcademicManagement(currentModule),
        inTeaching: Validations.inTeaching(currentModule),
        inConsolidation: Validations.inConsolidation(currentModule),
        inInvestigation: Validations.inInvestigation(currentModule),
        inExtension: Validations.inExtension(currentModule),
        isTeacher: Validations.isTeacher(currentRoleId),
        currentModule: currentModule,
        endExecution: endExecution,
        endAproval: endAproval,
        endEvaluation: endEvaluation,
        endReviewExecution: endReviewExecution,
        bitacora: bitacora
      })

      this.inExecution = Validations.inExecution(currentStage)
    // teacher ID varies depending of view
      let teacherId = this.teacherId
      let workplanId = this.workplanId
      let itemList = []

      function validateClass (scope) {
        if (!scope.inExecution) {
          scope.colClassTexts = 'col-md-7'
          scope.colClassButtons = 'col-md-5'
        }
      }

  // services

      const getSummanyProgress = Requests.getSummanyProgress(WorkPlanSrv)
      const setEndExecutionHeader = Requests.setEndExecutionHeader(GlobalConfig)
      const setEndAprovalHeader = Requests.setEndAprovalHeader(GlobalConfig)
      const setEndEvaluationHeader = Requests.setEndEvaluationHeader(GlobalConfig)
      const setEndReviewExecutionHeader = Requests.setEndReviewExecutionHeader(GlobalConfig)

      this.$onInit = () => {

        this.inprofilebutton=false

        
        if(this.inExecution==true && currentRoleId==13){
           this.inprofilebutton=true
        }

        getGeneralsWorkplan(this)
        validateClass(this)
      }

      function Entries (params) {
        WorkPlanSrv.getEntries.entries(params).$promise.then((response) => {
          if (!response.status) {
            ngNotify.set('Ocurrio un error en el servicio', 'warn')
          } else {
            $scope.totalData = response
          }
        }, (err) => {
          ngNotify.set('Imposible conectar con el servicio', 'error')
        })
      }

      function getGeneralsWorkplan (scope) {
        ReviewSrv.getWorkPlanGeneralDetail.get({teacherId: scope.teacherId}).$promise.then((dataReturn) => {
          if (dataReturn.status) {
            scope.executionCompleted = dataReturn.data.wokplanTeacherStatus[0].executionFinish === 1
            scope.evaluationCompleted = dataReturn.data.wokplanTeacherStatus[0].evaluationFinished === 1
            scope.userId = dataReturn.data.wokplanTeacherStatus[0].userId
          }
        })
      }

      function bitacora (ev) {
        this.entries.params = {
          activityTypeId: this.activitytypeId,
          workplanTeacherId: this.workplanteacherId,
          userId: this.userId
        }
        this.entries.title = this.btnBitacora.tagName
      // Entries(this.entries);
        this.entries.data = undefined
        $mdDialog.show({
          controller: 'bitacoraModalCtrl',
          controllerAs: 'bit',
          template: require('../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
          parent: angular.element(document.body),
          targetEvent: ev,
          locals: {data: this.entries},
          clickOutsideToClose: true,
          fullscreen: true
        })
      }

      function getNotify (idRole) {
        let reviewers = GlobalSrv.getReviewerbySubmodule(idRole, GlobalConfig.modules.execution)
        if (reviewers) {
          getSendNotify(reviewers)
        }
      }

      function getSendNotify (idUser) {
        let nameUser = JSON.parse($cookies.get('currentUser')).name
        let msg = 'El profesor ' + nameUser + ' ha finalizado la ejecución'

        let dataInbox = {
          idUser: idUser,
          dsName: 'Notificación, Apreciado Usuario el profesor ' + nameUser + ' ha finalizado la ejecución.',
          dsDescription: msg,
          idNotification_delivery_type: GlobalConfig.notificationType.inbox,
          is_grouped: 0
        }

        let dataEmail = {
          idUser: idUser,
          dsName: 'Notificación, Apreciado Usuario el profesor ' + nameUser + ' ha finalizado la ejecución.',
          dsDescription: msg,
          idNotification_delivery_type: GlobalConfig.notificationType.email,
          is_grouped: 0
        }

        GlobalSrv.sendNotification(dataInbox)
        GlobalSrv.sendNotification(dataEmail)
      }

      function endExecution () {
        let header = {
          teacherId: teacherId,
          workplanId: workplanId,
          id: user.id
        }

        let submodules = validateSubmodules()
        if (submodules.teaching) {
          getItemsRequiredList(header).then((promise) => {
            if (validateItems(submodules)) {
              showModalItemRequiredEndPlanning()
            } else {
              getSummanyProgress(header.teacherId).then((response) => {
                WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response))
                WorkPlanModalSrv.endPlanning().then((promise) => {
                  getNotify(GlobalConfig.userRolesIds.reviewer)
                })
              })
            }
          })
        }
      }

      function endAproval () {
        let post = {
          teacherId: teacherId,
          workplanId: workplanId,
          id: user.id,
          stageId: GlobalConfig.workplanIdStages.approval
        }
        WorkPlanSrv.getReprovedActivities.get(post).$promise.then((dataReturn) => {
          if (dataReturn.status) {
            WorkPlanModalSrv.setVariable(setEndAprovalHeader(post, currentStage, dataReturn.data))
            WorkPlanModalSrv.endStage().then((promise) => {
            })
          }
        })
      }

      function endEvaluation () {
        let post = {
          teacherId: teacherId,
          workplanId: workplanId,
          id: user.id,
          stageId: GlobalConfig.workplanIdStages.evaluation
        }
        WorkPlanSrv.getReprovedActivities.get(post).$promise.then((dataReturn) => {
          if (dataReturn.status) {
            WorkPlanModalSrv.setVariable(setEndEvaluationHeader(post, currentStage, dataReturn.data.noTouched))
            WorkPlanModalSrv.endStage().then((promise) => {

            })
          }
        })
      }

      function endReviewExecution () {
        let post = {
          teacherId: teacherId,
          workplanId: workplanId,
          id: user.id,
          stageId: GlobalConfig.workplanIdStages.reviewExecution
        }
        WorkPlanSrv.getReprovedActivities.get(post).$promise.then((dataReturn) => {
          if (dataReturn.status) {
            WorkPlanModalSrv.setVariable(setEndReviewExecutionHeader(post, currentStage, dataReturn.data.noTouched))
            WorkPlanModalSrv.endStage().then((promise) => {

            })
          }
        })
      }

      function addActivityTeaching () {
        WorkPlanModalSrv.addTeachingActivity()
      }

      function addActivityAM () {
        WorkPlanModalSrv.addAcademicManagementActivity()
      }

      function addRolesAM () {
        WorkPlanModalSrv.addAcademicManagementRole()
      }

      function addCommitteParticipationAM () {
        WorkPlanModalSrv.addAcademicManagementCommitteParticipation()
      }

      function viewOfferCoursesCP () {
        WorkPlanModalSrv.addConsolidationOfferCourses()
      }

      function viewTransversalProjects () {
        WorkPlanModalSrv.listTransversalProjects()
      }

      function addCourseExternalCP () {
        WorkPlanModalSrv.addConsolidationCourseExternal()
      }

      function addLearningComunityCP () {
        WorkPlanModalSrv.addConsolidationLearningComunity()
      }

      function getItemsRequiredList (header) {
        itemList = []
        return WorkPlanSrv.getItemRequiredExecution.getList(header)
        .$promise.then(function (dataReturn) {
          if (dataReturn.status) {
            var activities = []
            for (var i in dataReturn.assignatures) {
              for (var j in dataReturn.activities) {
                if (dataReturn.assignatures[i].id_assignature === dataReturn.activities[j].id_assignature) {
                  activities.push(dataReturn.activities[j])
                }
              }
              itemList.push({
                assignatureName: dataReturn.assignatures[i].assignatureName,
                assignatureId: dataReturn.assignatures[i].id_assignature,
                showChilds: false,
                itemList: activities
              })
              activities = []
            }
          } else {
            console.log('Comunications problem with the server')
          }
        }, function (data) {
          console.log(data)
        })
      }

      function validateSubmodules () {
        let validateSubmodules = {
          teaching: false,
          academicManagement: false
        }
        let submodule = JSON.parse($cookies.get('subModuleId'))
        for (var i in submodule) {
          if (submodule[i].submoduleId === GlobalConfig.modules.teaching) {
            validateSubmodules.teaching = true
          }
          if (submodule[i].submoduleId === GlobalConfig.modules.academicManagement) { validateSubmodules.academicManagement = true }
        }
        return validateSubmodules
      }

      function validateItems (submodule) {
        let showModal = false
        if (submodule.teaching) {
          if (itemList.length > 0) {
            showModal = true
          }
        }
        return showModal
      }

      function endPlanning () {
        let post = {
          teacherId: JSON.parse($cookies.get('currentUser')).teacherId,
          workplanId: JSON.parse($cookies.get('currentUser')).workplanId
        }

        let submodules = validateSubmodules()
        if (submodules.teaching) {
          getItemsRequiredList(post).then((promise) => {
            if (validateItems(submodules)) {
              showModalItemRequiredEndPlanning()
            } else {
              getSummanyProgress(header.teacherId).then((response) => {
                WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response))
                WorkPlanModalSrv.endPlanning().then((promise) => {
                })
              })
            }
          })
        }
      }

      function showModalItemRequiredEndPlanning () {
        let header = {
          itemAssignatures: itemList
        }
        WorkPlanModalSrv.setVariable(header)
        WorkPlanModalSrv.itemRequiredExecution()
      }
    }
  ]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/header.js